export interface BindingsDiff {
    idsToBind: string[];
    idsToUnbind: string[];
}

export function diffBindings(currentIds: string[], nextIds: string[]): BindingsDiff {
    return {
        idsToBind: nextIds.filter(id => !currentIds.includes(id)),
        idsToUnbind: currentIds.filter(id => !nextIds.includes(id)),
    };
}
